import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { POPIA_PAIA, PRIVACY, TERMS } from './policies-data';

@Component({
  selector: 'app-policy-viewer',
  templateUrl: './policy-viewer.component.html',
  styleUrls: ['./policy-viewer.component.scss']
})
export class PolicyViewerComponent implements OnInit {

  selectedPolicy?: { title: string, content: string };
  type?: string;

  constructor(public location: Location, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.type = params['type'] || null; // 'terms', 'privacy', 'popia', etc.

      switch (this.type) {
        case 'terms':
          this.selectedPolicy = TERMS;
          break;
        case 'privacy':
          this.selectedPolicy = PRIVACY;
          break;
        case 'popia':
          this.selectedPolicy = POPIA_PAIA;
          break;
        default:
          this.selectedPolicy = TERMS;
          break;
      }
    });
  }


}
